import { render, staticRenderFns } from "./ComparisonLegend.vue?vue&type=template&id=06ce531a"
import script from "./ComparisonLegend.vue?vue&type=script&lang=js"
export * from "./ComparisonLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports